import axios from 'axios';

class Popup {
    constructor() {
        this.news = document.querySelectorAll('.js-open-frame');
        if (this.news.length) {
            const url = document.URL.split('#');
            this.news.forEach((news) => {
                Popup.bindButton(news);
                if (url.length > 1 && url[1] === news.id) {
                    const heightHeader = document.querySelector('header').clientHeight;
                    Popup.showPopup(news);
                    setTimeout(() => {
                        window.scrollTo(0, window.scrollY - (heightHeader + 20));
                    }, 300);
                }
            });
        }

        this.news = document.querySelectorAll('.js-close-frame');
        if (this.news.length) {
            this.news.forEach((news) => {
                Popup.bindClose(news);
            });
        }
    }

    static bindButton(item) {
        item.addEventListener('click', () => {
            Popup.showPopup(item);
        });
    }

    static showPopup(item) {
        document.querySelector('body').classList.add('iframe-opened');
        const target = document.querySelector(item.dataset.frame);
        target.classList.add('visible');
        target.querySelectorAll('[data-src]').forEach((item) => {
            item.src = item.dataset.src;
        });
        target.querySelectorAll('[data-bio-id]').forEach((item) => {
            axios.get(`/speaker-bio/${item.dataset.bioId}`, {
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
            })
                .then((response) => {
                    item.innerHTML = response.data;
                });
        });
    }

    static bindClose(item) {
        item.addEventListener('click', () => {
            const target = item.closest('.iframe-popup.visible');
            target.classList.remove('visible');
            if (!document.querySelector('.iframe-popup.visible')) {
                document.querySelector('body').classList.remove('iframe-opened');
            }
        });
    }
}

export default Popup;
